import type { Point, Container } from 'pixi.js';
import { GAME_OBJECT_POOL } from 'game/GameConstants';
import MathUtils from 'utils/MathUtils';
import { TILE_EDGE_LENGTH, TILE_HEIGHT, TILE_WIDTH } from '../views/board/TileView';

/**
 * Coverts a global position to a grid position in the hex grid.
 * @param parent parent of hex stack
 * @param globalPos
 */
export function globalToGridPos(parent: Container, globalPos: Point): Point {
  const localPos = parent.toLocal(globalPos, undefined, GAME_OBJECT_POOL.getPoint());
  const gridPos = parent.toLocal(globalPos, undefined, GAME_OBJECT_POOL.getPoint());

  localPos.x += TILE_WIDTH / 2;
  localPos.y += TILE_HEIGHT / 2;

  gridPos.x = Math.floor(localPos.x / TILE_WIDTH);
  if (gridPos.x % 2) localPos.y -= TILE_HEIGHT / 2;
  gridPos.y = Math.floor(localPos.y / TILE_HEIGHT);

  const tileX = localPos.x / TILE_WIDTH - gridPos.x;
  const tileY = localPos.y / TILE_HEIGHT - gridPos.y;

  const edgeLength = TILE_EDGE_LENGTH;
  const cornerLength = 1 - TILE_EDGE_LENGTH;

  if (MathUtils.isPointLeftOfLine(tileX, tileY, 0, edgeLength, cornerLength, 1)) {
    gridPos.x -= 1;
    if (gridPos.x % 2 === 0) gridPos.y += 1;
  } else if (MathUtils.isPointLeftOfLine(tileX, tileY, edgeLength, 1, 1, edgeLength)) {
    gridPos.x += 1;
    if (gridPos.x % 2 === 0) gridPos.y += 1;
  } else if (MathUtils.isPointLeftOfLine(tileX, tileY, cornerLength, 0, 0, cornerLength)) {
    gridPos.x -= 1;
    if (gridPos.x % 2 !== 0) gridPos.y -= 1;
  } else if (MathUtils.isPointLeftOfLine(tileX, tileY, 1, cornerLength, edgeLength, 0)) {
    gridPos.x += 1;
    if (gridPos.x % 2 !== 0) gridPos.y -= 1;
  }

  GAME_OBJECT_POOL.addPoint(localPos);
  return gridPos;
}
